export default __webpack_public_path__ + "static/media/filter_document.38945b6e.svg";